import { put, takeLatest } from 'redux-saga/effects';
import config from '@/config';
import { HTTP_CODE, STATE_KEY, TOKEN_KEY, USER_KEY } from '@/common/constant';
import { parseQueryString } from '@/common/utils';
import Api from '@/common/api';

import {
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  LOGIN,
  LOGIN_SUCCESS,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  SIGN_OUT_USER,
  SIGN_OUT_USER_SUCCESS,
  VERIFY_TOKEN,
} from '../types/authenticate';
import { getToken } from '../utils/authenticate';
import {
  requestLoginApi,
  requestLogoutApi,
  requestRefreshTokenApi,
  requestResetPasswordApi,
  requestTokenApi,
} from '../requests/authenticate';

const api = Api.getApi();
const { client_id, client_secret, ssoUrl } = config;

/**
 * Handle login session
 * @param {*} param0
 */
function* login({ params, callback }) {
  try {
    const response = yield requestLoginApi(params);
    localStorage.setItem(USER_KEY, JSON.stringify(response.user));
    yield put({ type: LOGIN_SUCCESS, payload: response.user });
  } catch (err) {
    callback(err);
  }
}

/**
 * Handle reset password session
 * @param {*} param0
 */
function* resetPassword({ params, callback }) {
  try {
    const response = yield requestResetPasswordApi(params);
    yield put({ type: RESET_PASSWORD_SUCCESS, payload: response.user });
    callback();
  } catch (err) {
    callback(err);
  }
}

/**
 * Handle get current user
 * @param {*} param0
 */
function* getCurrentUser() {
  try {
    const user = localStorage.getItem(USER_KEY);
    yield put({ type: GET_CURRENT_USER_SUCCESS, payload: JSON.parse(user) });
  } catch (err) {}
}

/**
 * Handle sign out session
 * @param {*} param0
 */
function* signOutUser() {
  try {
    yield requestLogoutApi();
    localStorage.removeItem(USER_KEY);
    yield put({ type: SIGN_OUT_USER_SUCCESS });
  } catch (err) {
    // console.error('signOutUser : ', err);
  }
}

/**
 * Handle refresh token
 * @param {*} payload
 * @returns
 */
function* refreshToken(payload) {
  const { callback } = payload;
  try {
    const token = getToken();
    // Check token is exists
    if (!token && !Object.values(token).length) return;

    const { refresh_token, redirect_uri } = token;
    const queryString = new URLSearchParams({
      client_id,
      client_secret,
      redirect_uri,
      grant_type: 'refresh_token',
      refresh_token,
    }).toString();
    const newToken = yield requestRefreshTokenApi({ queryString, ssoUrl });
    const { expires_in, access_token } = newToken;
    const currentDate = new Date();
    const expires_date = currentDate.setSeconds(currentDate.getSeconds() + expires_in - 10);
    localStorage.setItem(
      TOKEN_KEY,
      JSON.stringify({
        ...newToken,
        expires_date,
        redirect_uri,
      }),
    );
    api.setToken(access_token);

    yield put({
      type: REFRESH_TOKEN_SUCCESS,
    });

    if (callback) yield callback(true);
  } catch (err) {
    if (err.responseError.status === HTTP_CODE[400] && callback) {
      yield callback(false);
    }
  }
}

/**
 * Handle request verify token
 * @param {*} payload
 */
function* requestVerifyToken(payload) {
  try {
    const { params, callback } = payload;
    const { search, redirect_uri } = params;
    const { state, code } = parseQueryString(search);
    const currentState = localStorage.getItem(STATE_KEY);
    const queryString = new URLSearchParams({
      client_id,
      client_secret,
      redirect_uri,
      grant_type: 'authorization_code',
      code,
    }).toString();
    let token = null;
    if (state === currentState) {
      token = yield requestTokenApi({ queryString, ssoUrl });
      const { expires_in } = token;
      const currentDate = new Date();
      const expires_date = currentDate.setSeconds(currentDate.getSeconds() + expires_in - 10);
      localStorage.setItem(
        TOKEN_KEY,
        JSON.stringify({
          ...token,
          expires_date,
          redirect_uri,
        }),
      );
    }
    callback(token);
  } catch (err) {
    //
  }
}

export default [
  takeLatest(LOGIN, login),
  takeLatest(RESET_PASSWORD, resetPassword),
  takeLatest(SIGN_OUT_USER, signOutUser),
  takeLatest(REFRESH_TOKEN, refreshToken),
  takeLatest(VERIFY_TOKEN, requestVerifyToken),
  takeLatest(GET_CURRENT_USER, getCurrentUser),
];
